module.exports = __webpack_public_path__ + "static/intro_final_desktop-fc8f35ffefe99ad803dfa502b802df73.mp4";